import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-v2-agent-search',
  templateUrl: './v2-agent-search.component.html',
  styleUrls: ['./v2-agent-search.component.css']
})
export class V2AgentSearchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
